export const ProductTypes = [
  {
    name: "Women's Clothing",
    value: "women_s_clothing",
    categories: [
      { name: "Dresses", value: "dresses" },
      { name: "Shorts & Skirts", value: "shorts_and_skirts" },
      { name: "Jeans", value: "jeans" },
      { name: "Shirts", value: "shirts" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Men's Clothing",
    value: "men_s_clothing",
    categories: [
      { name: "Slacks", value: "slacks" },
      { name: "Jeans", value: "jeans" },
      { name: "Shirts", value: "shirts" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Kid's Wear",
    value: "kid_s_wear",
    categories: [
      { name: "Frocks", value: "frocks" },
      { name: "Skirts", value: "skirts" },
      { name: "Jeans", value: "jeans" },
      { name: "Shirts", value: "shirts" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Party Wear",
    value: "party_wear",
    categories: [
      { name: "Long skirts", value: "long_skirts" },
      { name: "Frocks", value: "frocks" },
      { name: "Maxi dress", value: "maxi_dress" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Jewellery",
    value: "jewellery",
    categories: [
      { name: "Neck sets", value: "neck_sets" },
      { name: "Rings", value: "rings" },
      { name: "Chains", value: "chains" },
      { name: "Bracelets", value: "bracelets" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Watches",
    value: "watches",
    categories: [
      { name: "Leather strap", value: "leather_strap" },
      { name: "Steel strap", value: "steel_strap" },
      { name: "Chain type", value: "chain_type" },
      { name: "Iron strap", value: "iron_strap" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Shoes",
    value: "shoes",
    categories: [
      { name: "Women shoes", value: "women_shoes" },
      { name: "Men shoes", value: "men_shoes" },
      { name: "Casual shoes", value: "casual_shoes" },
      { name: "Running shoes", value: "running_shoes" },
      { name: "Other", value: "other" },
    ],
  },
  {
    name: "Handbags",
    value: "handbags",
    categories: [
      { name: "Leather", value: "leather" },
      { name: "Cotton bags", value: "cotton_bags" },
      { name: "Wallets", value: "wallets" },
      { name: "Jeans bags", value: "jeans_bags" },
      { name: "Other", value: "other" },
    ],
  },
];
